import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import AccessibleDropdown from 'common/AccessibleDropdown';
import css from './ConnectionItemDropdown.scss';
import { defaultScheduleLinkForConnection } from 'utils/scheduler';
import { getTenantConfig } from 'utils/tenant';
import * as routes from "serviceCatalog/routes";

export default class ConnectionItemDropdown extends React.Component {

  get options() {

    const options = [];

    if ( this.props.onlineSchedulingAvailable ) {
      options.push({
        key: "key_1",
        as: 'a',
        value: this.scheduleLink,
        text: "Schedule",
        className: "scheduleButton"
      });
    }

    if ( this.props.email !== '' && this.props.email !== null ) {
      options.push({
        key: "key_2",
        as: "a",
        value: `mailto:${this.props.email}`,
        text: "Email"
      });
    }

    if ( this.props.phoneNumber !== '' && this.props.phoneNumber !== null ) {
      options.push({
        key: "key_3",
        as: "a",
        value: `tel:${this.props.phoneNumber}`,
        text: "Call"
      });
    }

    options.push({
      key: "key_4",
      as: 'a',
      value: routes.urlFragment(
        routes.toStaffUserInService({
          staffUserId: this.props.personId,
          serviceId: this.props.serviceId
        })),
      text: "View Profile"
    });

    return options;
  }

  get scheduleLink() {
    return getTenantConfig('MOBILE_APPOINTMENTS_ENABLED')
      ? routes.urlFragment(
         routes.toScheduleStaffUserAppointmentForService({
            staffUserId: this.props.personId,
            serviceId: this.props.serviceId
         }))
      : defaultScheduleLinkForConnection(this.props.personId);
  }

  render() {
    return (
      <AccessibleDropdown
        icon='ellipsis horizontal'
        id={this.props.personId}
        upward={this.props.upward}
        value={false} // Needed because we don't want ENTER to select any value
        className={css['item-dropdown']}
        aria-label={this.props.fullName}
        options={this.options}
        selectOnBlur={false}
        selectOnNavigation={false}
        openOnFocus={false}
        onChange={(e, {value}) => { window.location.href = value; }}
      />
    );
  }
}

ConnectionItemDropdown.propTypes = {
  personId: SFEntityID.isRequired,
  fullName: PropTypes.string,
  onlineSchedulingAvailable: PropTypes.bool,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  serviceId: SFEntityID,
  upward: PropTypes.bool
};
